module.exports = __webpack_public_path__ + "img/counter_single_ledge.78604fe9.png";